export default __webpack_public_path__ + "static/canvas-a012cd58586eef4f418a2ba313bc5029.jpg";